import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useWalkthrough } from './walkthrough-context';

const QuestionMarkIcon = ({ size = '1rem' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1C9.82441 1 7.69767 1.64514 5.88873 2.85383C4.07979 4.06253 2.66989 5.78049 1.83733 7.79048C1.00477 9.80047 0.78693 12.0122 1.21137 14.146C1.6358 16.2798 2.68345 18.2398 4.22183 19.7782C5.76021 21.3165 7.72022 22.3642 9.85401 22.7886C11.9878 23.2131 14.1995 22.9952 16.2095 22.1627C18.2195 21.3301 19.9375 19.9202 21.1462 18.1113C22.3549 16.3023 23 14.1756 23 12C23 9.08262 21.8411 6.28472 19.7782 4.22182C17.7153 2.15893 14.9174 1 12 1Z"
      stroke="#2F80ED"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M8.49805 8.6436C8.49805 8.6436 8.55055 7.54985 9.72117 6.60797C10.4155 6.0486 11.248 5.88672 11.998 5.87547C12.6812 5.86672 13.2912 5.97985 13.6562 6.1536C14.2812 6.4511 15.498 7.17735 15.498 8.72172C15.498 10.3467 14.4355 11.0848 13.2249 11.8967C12.0143 12.7086 11.6855 13.5898 11.6855 14.5005"
      stroke="#2F80ED"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M11.626 19.001C12.3163 19.001 12.876 18.4413 12.876 17.751C12.876 17.0606 12.3163 16.501 11.626 16.501C10.9356 16.501 10.376 17.0606 10.376 17.751C10.376 18.4413 10.9356 19.001 11.626 19.001Z"
      fill="#2F80ED"
    />
  </svg>
);

export const HelpButton = ({ forceFullWalkthrough = false }) => {
  const navigate = useNavigate();
  const { state, currentStep, startWalkthrough, resumeWalkthrough, steps } =
    useWalkthrough();

  // Check if user has ever completed/dismissed the global walkthrough
  const hasCompletedOnboarding = state.completed || state.dismissed;

  // Check if walkthrough is currently in progress
  const isInProgress =
    state.startedAt &&
    !state.completed &&
    !state.dismissed &&
    state.currentStep > 0;

  const handleClick = () => {
    if (forceFullWalkthrough) {
      // Dashboard or pages without page-specific content: always start full walkthrough
      startWalkthrough();
      if (steps?.[0]?.path) {
        navigate(steps[0].path);
      }
    } else if (hasCompletedOnboarding) {
      // Returning user: trigger page-specific joyride
      window.dispatchEvent(new CustomEvent('scheduler-help'));
    } else if (isInProgress) {
      // In-progress: resume global walkthrough
      resumeWalkthrough();
      if (currentStep?.path) {
        navigate(currentStep.path);
      }
    } else {
      // First-time user: start global onboarding walkthrough
      startWalkthrough();
      if (steps?.[0]?.path) {
        navigate(steps[0].path);
      }
    }
  };

  return (
    <button
      onClick={handleClick}
      className="text-blue-hover font-semibold inline-flex items-center hover:opacity-80 transition-opacity"
      title={isInProgress ? 'Resume walkthrough' : 'Start walkthrough'}
    >
      <span>How to</span>
      <span className="relative">
        <QuestionMarkIcon size="1rem" />
        {isInProgress && (
          <span className="absolute -top-1 -right-1 flex h-3 w-3 items-center justify-center rounded-full bg-red-500 text-[8px] font-bold text-white">
            {state.currentStep + 1}
          </span>
        )}
      </span>
    </button>
  );
};
